import { render, staticRenderFns } from "./announcementModal.vue?vue&type=template&id=2e173022&scoped=true"
import script from "./announcementModal.vue?vue&type=script&lang=js"
export * from "./announcementModal.vue?vue&type=script&lang=js"
import style0 from "./announcementModal.vue?vue&type=style&index=0&id=2e173022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e173022",
  null
  
)

export default component.exports